import { HashMap1a0ld5kgwhmhv as HashMap } from './HashMap.mjs';
import { KtMutableMap1kqeifoi36kpz as KtMutableMap } from './Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function init_kotlin_collections_LinkedHashMap(_this__u8e3s4) {
}
var LinkedHashMapClass;
function LinkedHashMap() {
  if (LinkedHashMapClass === VOID) {
    class $ extends HashMap() {
      static bc() {
        var $this = this.r8();
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static cc(initialCapacity) {
        var $this = this.f9(initialCapacity);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      static dc(original) {
        var $this = this.g9(original);
        init_kotlin_collections_LinkedHashMap($this);
        return $this;
      }
      o6() {
        return this.o8_1.q9();
      }
    }
    initMetadataForClass($, 'LinkedHashMap', $.bc, VOID, [KtMutableMap()]);
    LinkedHashMapClass = $;
  }
  return LinkedHashMapClass;
}
//region block: exports
export {
  LinkedHashMap as LinkedHashMap1zhqxkxv3xnkl,
};
//endregion

//# sourceMappingURL=LinkedHashMap.mjs.map
